import { PrivacyTypes, type ProfileV2 } from '../../../types';

// Todo - convert this to a named export
// eslint-disable-next-line import/no-default-export
export default function ({ hasResume, profilePrivacy }: ProfileV2): boolean {
  return hasResume !== null ? profilePrivacy === PrivacyTypes.Standard : false;
}
